import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      '.PhoneInputInput': {
        backgroundColor: '#fff',
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(24),
    },
    controlList: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: rem(12),
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
      },
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
      },
      '.phone-input': {
        '&,& .PhoneInput': {
          marginBottom: 0,
        },
      },
    },
    control: {
      flex: '0 0 48%',
    },
    nameControl: {
      flex: 'none',
      width: '100%',
    },
    controlErr: {
      fontSize: rem(14),
    },
    hint: { textAlign: 'center' },
    actionList: {
      display: 'flex',
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
        gap: 'inherit',
      },
      [theme.fn.largerThan('sm')]: {
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: rem(16),
        width: '100%',
      },
    },
    submitBtn: {
      // [theme.fn.smallerThan('sm')]: {
      //   ...(isModal && {
      //     position: 'fixed',
      //     left: rem(15),
      //     right: rem(15),
      //     bottom: rem(16),
      //     width: 'auto',
      //   }),
      // },
    },
    successBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(8),
      alignItems: 'center',
    },
    successImg: {
      width: rem(160),
    },
  }
})
